var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16672 8.16674L2.66668 5.91672L2.66668 4.33337L8.41675 8.16674L1 13.2501L1 18.9169L8.75008 13.5835L7.25007 12.5001L2.75002 15.5835V14.1668L11.4168 8.16674L1 1L1 6.83339L4.66671 9.33342L6.16672 8.16674ZM13.8332 11.8335L17.3333 14.0835V15.6669L11.5832 11.8335L19 6.75009V1.08337L11.2499 6.41676L12.7499 7.5001L17.2499 4.41674V5.83342L8.58318 11.8335L19 19.0002V13.1668L15.3333 10.6668L13.8332 11.8335Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdo);
export default __webpack_public_path__ + "static/media/ido.e4dc2c82.svg";
export { ForwardRef as ReactComponent };